// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";  
//查询居民上报策略配置详情
export  function detailApi() {
  return request<API.ResponseData>("/wrs/resiReportStrategy/detail", {
    method: "GET", 
  });
}
  
//保存居民上报策略配置
export  function saveApi(params:any) {
  return request<API.ResponseData>("/wrs/resiReportStrategy/save", {
    method: "POST", 
    data: params
  });
} 
  //保存居民上报策略配置
export  function overviewApi(params:any) {
  return request<API.ResponseData>("/wrs/resiReportStrategy/overview", {
    method: "POST", 
    data: params
  });
}

  
//保存居民上报策略配置
export  function autoReportConfigApi() {
  return request<API.ResponseData>("/wrs/resiReportStrategy/autoReportConfig", {
    method: "GET",  
  });
} 
//手动触发今日数据生成
export  function generateTodayDataApi(params:any) {
  return request<API.ResponseData>("/wrs/resiReportStrategy/generateTodayData", {
    method: "POST", 
    data: params
  });
}
//重新计算偏差
export  function recalculateDeviationApi(params:any) {
  return request<API.ResponseData>("/wrs/resiReportStrategy/recalculateDeviation", {
    method: "GET", 
    params: params
  });
}
 //重新计算偏差
export  function refreshSummaryRuleRelApi(params:any) {
  return request<API.ResponseData>("/wrs/resiReportStrategy/refreshSummaryRuleRel", {
    method: "POST", 
    data: params
  });
}
